module.exports = __webpack_public_path__ + "static/media/09.e18bd700.jpg";